import { AlertTriangle } from "lucide-react";
import {
  Alert,
  AlertDescription,
  AlertTitle,
} from "../../../components/ui/alert";

interface MissingFieldsAlertProps {
  /** Rótulos dos campos ausentes, vindos de getMissingRequiredFields. */
  missingFields: string[];
  /** Frase de orientação ao operador, específica de cada tela. */
  description: string;
}

/**
 * Avisa o operador quais campos obrigatórios do cadastro estão vazios, para que
 * ele saiba o que buscar manualmente. Não bloqueia nenhuma ação.
 */
export function MissingFieldsAlert({
  missingFields,
  description,
}: MissingFieldsAlertProps) {
  if (missingFields.length === 0) return null;

  return (
    <Alert variant="destructive" className="mb-4">
      <AlertTriangle className="h-4 w-4" />
      <AlertTitle>
        {missingFields.length === 1
          ? "1 campo obrigatório está faltando"
          : `${missingFields.length} campos obrigatórios estão faltando`}
      </AlertTitle>
      <AlertDescription>
        <ul className="mt-2 list-disc space-y-1 pl-4">
          {missingFields.map((field) => (
            <li key={field}>{field}</li>
          ))}
        </ul>
        <p className="mt-2">{description}</p>
      </AlertDescription>
    </Alert>
  );
}
